import { uniqueId } from 'lodash';

export const generateRandomNumber = () => {
  return uniqueId(`${Math.floor(Math.random() * 900000) + 100000}-`);
};
